<div *ngIf="pageDesignFlag">
  <div id="{{pageDesign.name}}" [ngStyle]="pageDesign.style">
    
    <div class="row" id="start-action-button-container" *ngIf="pageDesign.back_button && enableBackBtn">
    
      <img [src]="appService.back_button_icon" class="back-button" alt="" srcset=""  (click)="loadPrevious()"  [ngStyle]="appService.getBackButtonStyle()">
    
    </div>

    <div class="full-width">

      <!-- CUSTOM CODE SECTION -->
      <div *ngIf="customDesign">
    
        <div [innerHTML]="htmlText | sanitizeHtml"></div>
    
      </div>
      
      <!-- NON CUSTOM CODE SECTION -->
      <div *ngIf="!customDesign">

        <!-- PAGE DIVISION ENABLED -->
        <div *ngIf="pageDivision" >

          <!-- TWO COLOUMNS -->
          <div [ngStyle]="pageDivStyle">
            
            <div [ngStyle]="pageLeftScreenStyle">
                
              <div *ngFor="let ele of pageDesign.left_screen_element_flow" class="element-div">
              
                <img *ngIf="ele.type=='image'" src="{{ele.src}}" alt="" srcset="" [ngStyle]="ele.style">
              
                <p *ngIf="ele.type=='text'" [ngStyle]="ele.style">{{ele.text}}</p>
              
                <p *ngIf="ele.type=='sub-text' && ele.text!= 'null'" [ngStyle]="ele.style">{{ele.text}}</p>
              
                <p *ngIf="ele.type=='link'" [ngStyle]="ele.style">{{ele.text}}&nbsp;<a [href]="ele.link" target="_blank">{{ele.linkText}}</a></p>
            
                <button mat-raised-button *ngIf="ele.type=='button'" [ngStyle]="ele.style"
                  (click)="customService.triggerFunction(ele)">{{ele.text}}</button>
          
                <label for="file-upload" *ngIf="ele.type=='file-input'" [ngStyle]="ele.style"
                  (click)="customService.triggerFunction(ele)">
                  {{ele.text}}
                </label>
           
                <input class="explore-button" *ngIf="ele.type=='file-input'" id="file-upload" type="file" accept="image/png, image/jpeg"
                  (change)="fileProgress($event)" #photoInput />
          
              </div>
      
            </div>
            <div [ngStyle]="pageRightScreenStyle">
              
              <div style="flex-direction: column;align-items: center;justify-content: center;">
              
                <div *ngFor="let ele of pageDesign.right_screen_element_flow" class="element-div">
              
                  <img *ngIf="ele.type=='image'" src="{{ele.src}}" alt="" srcset="" [ngStyle]="ele.style">
              
                  <p *ngIf="ele.type=='text'" [ngStyle]="ele.style">{{ele.text}}</p>
              
                  <p *ngIf="ele.type=='sub-text' && ele.text!= 'null'" [ngStyle]="ele.style">{{ele.text}}</p>
              
                  <p *ngIf="ele.type=='link'" [ngStyle]="ele.style">{{ele.text}}&nbsp;<a [href]="ele.link" target="_blank">{{ele.linkText}}</a></p>
              
                  <button mat-raised-button *ngIf="ele.type=='button'" [ngStyle]="ele.style"
                    (click)="customService.triggerFunction(ele)">{{ele.text}}</button>
            
                  <label for="file-upload" *ngIf="ele.type=='file-input'" [ngStyle]="ele.style"
                    (click)="customService.triggerFunction(ele)">
                    {{ele.text}}
                  </label>
            
                  <input class="explore-button" *ngIf="ele.type=='file-input'" id="file-upload" type="file" accept="image/png, image/jpeg"
                    (change)="fileProgress($event)" #photoInput />
            
                </div>
              
              </div>
            
            </div>

          </div>
          
          <!-- ROW WISE -->
          <div>
          
            <div *ngFor="let ele of pageDesign.element_flow" class="element-div">
          
              <img *ngIf="ele.type=='image'" src="{{ele.src}}" alt="" srcset="" [ngStyle]="ele.style">
          
              <p *ngIf="ele.type=='text'" [ngStyle]="ele.style">{{ele.text}}</p>
          
              <p *ngIf="ele.type=='sub-text' && ele.text!= 'null'" [ngStyle]="ele.style">{{ele.text}}</p>
          
              <p *ngIf="ele.type=='link'" [ngStyle]="ele.style">{{ele.text}}&nbsp;<a [href]="ele.link" target="_blank">{{ele.linkText}}</a></p>
          
              <button mat-raised-button *ngIf="ele.type=='button'" [ngStyle]="ele.style"
                (click)="customService.triggerFunction(ele)">{{ele.text}}</button>
        
              <label for="file-upload" *ngIf="ele.type=='file-input'" [ngStyle]="ele.style"
                (click)="customService.triggerFunction(ele)">
                {{ele.text}}
              </label>
        
              <input class="explore-button" *ngIf="ele.type=='file-input'" id="file-upload" type="file" accept="image/png, image/jpeg"
                 #photoInput />
          
            </div>
          
          </div>

        </div>

        <!-- PAGE DIVISION DISABLED -->
        <div *ngIf="!pageDivision">
          
          <div *ngFor="let ele of pageDesign.element_flow" class="ele-div">
          
            <img *ngIf="ele.type=='image'" src="{{ele.src}}" alt="" srcset="" [ngStyle]="ele.style">
          
            <p *ngIf="ele.type=='text'" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml"></p>
          
            <p *ngIf="ele.type=='link'" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml">&nbsp;<a [href]="ele.link" target="_blank">{{ele.linkText}}</a></p>
          
            <p *ngIf="ele.type=='sub-text' && ele.text!= 'null'" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml"></p>
            
            <button mat-raised-button *ngIf="ele.type=='button'" [ngStyle]="ele.style"
              (click)="customService.triggerFunction(ele)" [innerHTML]="ele.text | sanitizeHtml"></button>
    
            <input type="file" class="explore-button" *ngIf="ele.type=='file-input'" id="file-upload" style="position: absolute;height:0"
              (change)="fileProgress($event)" #photoInput accept="image/png, image/jpeg"/>
          
            <label for="file-upload" *ngIf="ele.type=='file-input'" [ngStyle]="ele.style"
              (click)="uploadImage(ele)" [innerHTML]="ele.text | sanitizeHtml">
            </label>

            <div *ngIf="ele.type=='custom'" [innerHTML]="ele.custom_html | sanitizeHtml"></div>
          
          </div>
        
        </div>

      </div>

    </div>

    <!-- HIDDEN UPLOAD BUTTON FOR TRIGGERING FROM BACKEND -->
    <input type="file" accept="image/png, image/jpeg" #file id="upload_button" (change)="fileProgress($event)" #uploadBtn style="display: none;">

  </div>
</div>
